const style = window.getComputedStyle(document.body);

// цвета по умолчанию
export const DEFAULT_COLOR = style.getPropertyValue('--color-accent-blue');
export const DEFAULT_INNER_COLOR = style.getPropertyValue('--color-on-accent');

// прозрачности заливки
export const FILL_ALPHA_BASE = 0.25;
export const FILL_ALPHA_HOVER = 0.15;

// отступы
export const FIRST_OUTLINE_PADDING = 2; // Доп. отступ подсветки у первой точки
export const CLOSE_OUTLINE_PADDING = 6; // Доп. отступ подсветки при «готов к замыканию»

// радиус, при котором клик/курсор "считается рядом" с первой точкой
export const CLOSE_RADIUS_PX = 10;

// толщина hit-зоны ребра
export const HIT_STROKE_WIDTH_PX = 12;

export const CURSORS = {
  draw: 'crosshair',
  pointer: 'pointer',
  grab: 'grab',
  move: 'move',
  default: 'default',
} as const;

export const POLYGON_METRICS: {
  strokeWidthDefault: number;
  strokeWidthHover: number;
  vertexRadiusPx: number;
} = {
  strokeWidthDefault: 1,
  strokeWidthHover: 2,
  vertexRadiusPx: 4,
};
